/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  ManutenzioneCalendarioDto,
  GetManutenzioniParams,
} from ".././models";

export const getManutenzioni = (
  portale: 1 | 2 | 3,
  params?: GetManutenzioniParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ManutenzioneCalendarioDto[]>> => {
  return axios.get(`/api/portali/${portale}/manutenzioni`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetManutenzioniQueryKey = (
  portale: 1 | 2 | 3,
  params?: GetManutenzioniParams
) =>
  [
    `/api/portali/${portale}/manutenzioni`,
    ...(params ? [params] : []),
  ] as const;

export const getGetManutenzioniQueryOptions = <
  TData = Awaited<ReturnType<typeof getManutenzioni>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  params?: GetManutenzioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getManutenzioni>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getManutenzioni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetManutenzioniQueryKey(portale, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getManutenzioni>>> = ({
    signal,
  }) => getManutenzioni(portale, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!portale, ...queryOptions };
};

export type GetManutenzioniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getManutenzioni>>
>;
export type GetManutenzioniQueryError = AxiosError<unknown>;

export const useGetManutenzioni = <
  TData = Awaited<ReturnType<typeof getManutenzioni>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  params?: GetManutenzioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getManutenzioni>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetManutenzioniQueryOptions(portale, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetManutenzioni = () =>
  //@ts-ignore
  useGetManutenzioni(...([] as any[]));
